import React from "react";
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import ColorsContext from './ColorsContext';
import ColorsDefault from './ColorsDefault';
import Main from "./Main";
import theme from "./theme"

function App() {
  return (
    <div>
      <ThemeProvider theme={theme}>
        <ColorsContext.Provider value={ColorsDefault}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Main />
          </LocalizationProvider>
        </ColorsContext.Provider>
      </ThemeProvider>
    </div>
  );
}

export default App;
